import { render, staticRenderFns } from "./Faces.vue?vue&type=template&id=3ac9a130&scoped=true&"
import script from "./Faces.vue?vue&type=script&lang=js&"
export * from "./Faces.vue?vue&type=script&lang=js&"
import style0 from "./Faces.vue?vue&type=style&index=0&id=3ac9a130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac9a130",
  null
  
)

export default component.exports